import { Routes } from '@angular/router';
import { MainLayoutComponent } from './core/layouts/main-layout/main-layout.component';
import { OnboardingDashboardComponent } from './features/onboarding/pages/onboarding-dashboard.component';
import { OnboardingTemplatesComponent } from './features/onboarding/pages/onboarding-templates/onboarding-templates.component';

export const routes: Routes = [
    {
        path: 'forms/vpf/:id',
        loadComponent: () => import('./features/vendors/components/public-vendor-form/public-vendor-form.component').then(m => m.PublicVendorFormComponent)
    },
    {
        path: 'forms/onboarding-form/:token',
        loadComponent: () => import('./features/onboarding/pages/public-onboarding-form/public-onboarding-form.component').then(m => m.PublicOnboardingFormComponent)
    },
    {
        path: 'forms/offboarding-form/:token',
        loadComponent: () => import('./features/offboarding/pages/public-offboarding-form/public-offboarding-form.component').then(m => m.PublicOffboardingFormComponent)
    },
    {
        path: 'forms/offboarding-exit-request',
        loadComponent: () =>
            import('./features/offboarding/pages/public-exit-request-form/public-exit-request-form.component')
                .then(m => m.PublicExitRequestFormComponent)
    },
    {
        path: 'offboarding/task/:token',
        loadComponent: () => import('./features/offboarding/pages/public-task-view/public-task-view.component').then(m => m.PublicTaskViewComponent)
    },
    {
        path: 'offboarding/approve/:token',
        loadComponent: () => import('./features/offboarding/pages/public-exit-approval/public-exit-approval.component')
            .then(m => m.PublicExitApprovalComponent)
    },
    {
        path: 'budget-approval/:token',
        loadComponent: () => import('./features/recruitment/pages/public-budget-approval/public-budget-approval.component').then(m => m.PublicBudgetApprovalComponent)
    },
    {
        path: 'apply/:token',
        loadComponent: () => import('./features/recruitment/pages/public-job-apply/public-job-apply.component').then(m => m.PublicJobApplyComponent)
    },
    {
        path: 'careers/:orgId',
        loadComponent: () => import('./features/recruitment/pages/public-careers/public-careers.component').then(m => m.PublicCareersComponent)
    },
    {
        path: 'careers',
        loadComponent: () => import('./features/recruitment/pages/public-careers/public-careers.component').then(m => m.PublicCareersComponent)
    },
    {
        path: 'recruitment/apply/:token',
        redirectTo: 'apply/:token',
        pathMatch: 'full'
    },
    {
        path: 'onboarding/sign/:token',
        loadComponent: () => import('./features/onboarding/pages/public-signature/public-signature.component')
            .then(m => m.PublicSignatureComponent)
    },
    {
        path: 'offboarding/sign/:token',
        loadComponent: () => import('./features/offboarding/pages/public-signature/public-signature.component')
            .then(m => m.PublicSignatureComponent)
    },
    {
        path: 'vendors/sign/:token',
        loadComponent: () => import('./features/vendors/pages/public-vendor-signature/public-vendor-signature.component')
            .then(m => m.PublicVendorSignatureComponent)
    },
    {
        path: 'recruitment/voice-interview',
        loadComponent: () =>
            import('./features/recruitment/pages/voice-interview/voice-interview.component')
                .then(m => m.VoiceInterviewComponent)
    },
    {
        path: 'learning/public/training-access',
        loadComponent: () => import('./features/employee/pages/public-training-access/public-training-access.component').then(m => m.PublicTrainingAccessComponent)
    },
    {
        path: 'learning/public/learning-path-access',
        loadComponent: () => import('./features/employee/pages/public-learning-path-access/public-learning-path-access.component').then(m => m.PublicLearningPathAccessComponent)
    },
    {
        path: 'learning/public/take-assessment',
        loadComponent: () => import('./features/employee/pages/public-take-assessment/public-take-assessment.component').then(m => m.PublicTakeAssessmentComponent)
    },
    {
        path: 'auth',
        loadChildren: () => import('./routes/auth/auth.routes').then(m => m.AUTH_ROUTES)
    },
    // Standalone Recruitment routes (no app sidebar)
    {
        path: 'recruitment/interviewer-login',
        loadComponent: () => import('./features/recruitment/pages/interviewer-login/interviewer-login.component').then(m => m.InterviewerLoginComponent)
    },
    {
        path: 'recruitment/scheduled-interviews',
        loadComponent: () => import('./features/recruitment/pages/scheduled-interviews/scheduled-interviews.component').then(m => m.ScheduledInterviewsComponent)
    },
    {
        path: 'recruitment/interviewer/candidate-profile',
        loadComponent: () => import('./features/recruitment/pages/candidate-profile/candidate-profile-page.component').then(m => m.CandidateProfilePageComponent)
    },
    // Approver portal — standalone (no app sidebar)
    {
        path: 'approver',
        loadChildren: () =>
            import('./routes/approver/approver.routes').then(m => m.APPROVER_ROUTES)
    },
    // Employee Self-Service Portal — standalone per-org (no app sidebar)
    {
        path: 'ep',
        loadChildren: () =>
            import('./routes/employee-portal/employee-portal.routes').then(m => m.EMPLOYEE_PORTAL_ROUTES)
    },
    {
        path: '',
        redirectTo: 'auth/login',
        pathMatch: 'full'
    },
    {
        path: '',
        component: MainLayoutComponent,
        children: [
            {
                path: 'dashboard',
                redirectTo: 'recruitment/dashboard',
                pathMatch: 'full'
            },
            {
                path: 'recruitment',
                loadChildren: () =>
                    import('./routes/recruitment/recruitment.routes')
                        .then(m => m.RECRUITMENT_ROUTES)
            },
            {
                path: 'settings',
                loadChildren: () =>
                    import('./routes/settings/settings.routes')
                        .then(m => m.SETTINGS_ROUTES)
            },
            {
                path: 'vendors',
                loadChildren: () =>
                    import('./routes/vendors/vendors.routes')
                        .then(m => m.VENDORS_ROUTES)
            },
            {
                path: 'vendor-finance',
                loadChildren: () =>
                    import('./features/vendor-finance/vendor-finance.routes')
                        .then(m => m.VENDOR_FINANCE_ROUTES)
            },
            {
                path: 'vendor-evaluation',
                loadChildren: () =>
                    import('./features/vendor-evaluation/vendor-evaluation.routes')
                        .then(m => m.VENDOR_EVALUATION_ROUTES)
            },
            {
                path: 'employee',
                loadChildren: () =>
                    import('./features/employee/employee.routes')
                        .then(m => m.EMPLOYEE_ROUTES)
            },
            {
              path: 'onboarding',
                loadChildren: () =>
                    import('./features/onboarding/onboarding.routes')
                        .then(m => m.ONBOARDING_ROUTES)
            },

            {
                path: 'offboarding/request-form/:token',
                loadChildren: () =>
                    import('./features/offboarding/offboarding.routes')
                        .then(m => m.OFFBOARDING_ROUTES)
            },
            {
              path: 'offboarding',
                loadChildren: () =>
                    import('./features/offboarding/offboarding.routes')
                        .then(m => m.OFFBOARDING_ROUTES)
            }
        ]
    },
];
